import { render, staticRenderFns } from "./PatientModal.vue?vue&type=template&id=4dca2b3b&scoped=true"
import script from "./PatientModal.vue?vue&type=script&lang=ts"
export * from "./PatientModal.vue?vue&type=script&lang=ts"
import style0 from "./PatientModal.vue?vue&type=style&index=0&id=4dca2b3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca2b3b",
  null
  
)

export default component.exports